import { Table, Typography } from "antd"
import { useConsultationCalendarEvents } from "../calendar/calendarQueries"
import { CalendarEvent } from "../calendar/calendarModel"

export type Props = {
  customerId?: number
}

const humanDate = (x: string) => new Date(x).toDateString()
const urlDate = (x: string) => new Date(x).toISOString().substring(0, 10)

const ScheduledJobsList = ({ customerId }: Props) => {
  const eventsQuery =  useConsultationCalendarEvents(customerId)
  const events = eventsQuery.data ?? []
  events.sort((a, b) => b.start.localeCompare(a.start))

  const renderScheduledOn = (x: CalendarEvent) => {
    const startDate = humanDate(x.start)
    const endDate = humanDate(x.end)
    const display = startDate === endDate ? startDate : `${startDate} - ${endDate}`
    const href = `#!/calendar?date=${urlDate(x.start)}&project=${x.projectId}&task=${x.projectWorkareaId}&consultationId=${x.consultationId}`
    return <Typography.Link href={href} target="_blank">{display}</Typography.Link>
  }

  return <Table
    size="small"
    dataSource={events}
    loading={eventsQuery.isLoading}
    rowKey={x => x.id}
    columns={[
      { title: 'Scheduled On', render: (_, x) => renderScheduledOn(x) },
      { title: 'Type', render: (_, x) => x.consultationId ? 'Consultation' : 'Project' },
      { title: 'Title', dataIndex: 'title' },
      { title: 'Assigned To', dataIndex: 'crewForemanEmail' },
    ]}
    pagination={{
      pageSize: 50,
      hideOnSinglePage: true,
    }}
  />
}

export default ScheduledJobsList
